import { render } from "./PpcBABudgetCell.vue?vue&type=template&id=0aa15444&scoped=true"
import script from "./PpcBABudgetCell.vue?vue&type=script&lang=js"
export * from "./PpcBABudgetCell.vue?vue&type=script&lang=js"

import "./PpcBABudgetCell.vue?vue&type=style&index=0&id=0aa15444&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa15444"]])

export default __exports__